import { useEffect } from 'react'
import { PolicyPage, PageShell } from './PolicyPage'
export default function NotificationsPolicy() {
  useEffect(() => { document.title = 'Notifications Policy — SYNINN' }, [])
  return <PolicyPage title="Notifications Policy" subtitle="How and why we communicate with you" sections={[
    { heading: 'What we send', items: ['Booking confirmations immediately after you book', 'Booking reminders 24 hours and 1 hour before your booking', 'Cancellation confirmations', 'Loyalty and reward updates'] },
    { heading: 'No spam commitment', text: 'SYNINN will never sell your contact details to advertisers. All communications are directly related to your account or bookings.' },
  ]} />
}